import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1
  },
  default: {
    border: 'none',
    color: '#ffffff',
    background: theme.colors.primary,
  },
  outline: {
    border: `2px solid ${theme.colors.secondary}`,
    color: theme.colors.secondary,
    background: 'transparent',
  },
  base: {
    height: '76px',
    boxSizing: 'border-box',
    borderRadius: '8px',

    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '28px',
    textAlign: 'center',

    cursor: 'pointer',

    '@media(max-height: 976px)': {
      height: '60px',
      fontSize: '20px',
    },

    '&:disabled': {
      background: '#cfcfcf',
      color: '#828282',
      cursor: 'default'
    },

    '&:active': {
      opacity: 0.5
    }
  }
}))


function Button (props) {

  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  const onClick = () => {
    if (props.onClick) {
      props.onClick()
    }
  }

  const buttonStyle = `${styles.base} ${(props.outline ? styles.outline : styles.default )} ${(props.customStyles ? props.customStyles : '')}`
  return (
    <View className={styles.root}>
      <button 
        className={buttonStyle} 
        disabled={props.disabled}
        onClick={onClick}
      >
        {props.label}
      </button>
    </View>
  )
}

export default Button